import React from "react";
import Context from "../../../../Context";
import Blocker from "../../../Misc/Blocker";
export default class WorkdocRepair extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pending: false,
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let items = await this.context.api.qa("/repair/item/list", {
      filter: { documentid: this.props.id },
      orderby: ["itemid ASC"],
    });

    this.setState({ pending: false, items });
  };
  render() {
    const { items, pending } = this.state;
    const document = this.props.document || {};

    let summAmount = 0;
    let summCurrency = "";
    items.forEach((line) => {
      let item = line || {};
      let currency = item.currency || {};
      if (item.price) {
        summAmount += item.price * item.volume;
        summCurrency = currency.name;
      }
    });

    return (
      <>
        <Blocker on={pending} hAuto>
          <h5>{document.label}</h5>
          <div className="mb-4">
            <div className="my-2">
              Судно: <span className="text-muted">{document.shipname}</span>
            </div>

            {document.description && (
              <div className="my-2">
                Комментарий:{" "}
                <span className="text-muted">{document.description}</span>
              </div>
            )}
          </div>
          {items.map((line) => {
            let item = line || {};
            let structure = item.structure || {};
            let element = item.element || {};
            let model = item.model || {};
            let measure = item.measure || {};
            let currency = item.currency || {};
            return (
              <div key={item.itemid} className="py-3  ">
                <div className="d-flex bg-light">
                  <div className="border p-3 flex-grow-1">
                    <b>{item.itemid}.</b> {structure.name}
                  </div>
                  {element.label && (
                    <div className="border p-3 bg-light-primary">
                      {element.label}
                    </div>
                  )}
                </div>

                {item.price && (
                  <div className=" border p-3 text-right">
                    {item.price || ""} {currency.name}
                  </div>
                )}

                {model.name && (
                  <div className="d-flex  ">
                    <div className="col-10 border p-3">{model.name}</div>
                    {item.volume && (
                      <div className="col border p-3">
                        {item.volume || 0} {measure.name}
                      </div>
                    )}
                  </div>
                )}

                {item.description && (
                  <div className="border p-3 font-italic">
                    <span className="text-muted mr-2">Примечание:</span>
                    {item.description}
                  </div>
                )}

                {item.overhaul && (
                  <div className="border p-3">Капитальный ремонт</div>
                )}
              </div>
            );
          })}

          {summAmount > 0 && (
            <div className="mt-4 text-right">
              <h5>
                Итого: {summAmount} {summCurrency}
              </h5>
            </div>
          )}
        </Blocker>
      </>
    );
  }
}
